// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2T5ga","logo":"Footer_logo__rMwY2"};